export enum FormsIntelFormTypeEnum {
  HUBSPOT = 'HUBSPOT',
  HUBSPOT_LANDING_PAGE = 'HUBSPOT_LANDING_PAGE',
  MARKETO = 'MARKETO',
  MARKETO_LANDING_PAGE = 'MARKETO_LANDING_PAGE',
}
